module.exports = __webpack_public_path__ + "img/senalando-izqcr.73f4e702.png";